import CaptchaEvent from './Captcha.types';

function initFormSubmitInterceptor(form: HTMLFormElement, captchaInput: HTMLInputElement): void {
    let verified = false;
    let pending = false;
    let abortController: AbortController | null = null;

    form.addEventListener(
        'submit',
        (e: SubmitEvent) => {
            if (verified) {
                return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();

            if (pending) {
                return;
            }

            pending = true;
            abortController = new AbortController();
            const { signal } = abortController;

            const resetPending = (): void => {
                pending = false;
                abortController?.abort();
                abortController = null;
            };

            form.addEventListener(
                CaptchaEvent.SUCCESS,
                () => {
                    verified = true;
                    resetPending();
                    form.requestSubmit();
                },
                { once: true, signal }
            );

            form.addEventListener(CaptchaEvent.ERROR, resetPending, { once: true, signal });
            form.addEventListener(CaptchaEvent.EXPIRE, resetPending, { once: true, signal });

            captchaInput.dispatchEvent(new CustomEvent(CaptchaEvent.EXECUTE));
        },
        { capture: true }
    );
}

function initSocialLoginInterceptor(form: HTMLFormElement, captchaInput: HTMLInputElement): void {
    form.querySelectorAll<HTMLAnchorElement>('[data-role="social-login"]').forEach((anchor) => {
        const originalHref = anchor.href;

        anchor.addEventListener('click', (e: MouseEvent) => {
            e.preventDefault();

            const abortController = new AbortController();
            const { signal } = abortController;

            form.addEventListener(
                CaptchaEvent.SUCCESS,
                (event: Event) => {
                    const { token } = (event as CustomEvent<{ token: string }>).detail;
                    abortController.abort();

                    const url = new URL(originalHref);
                    url.searchParams.set('token', token);
                    window.location.href = url.toString();
                },
                { once: true, signal }
            );

            form.addEventListener(CaptchaEvent.ERROR, () => abortController.abort(), {
                once: true,
                signal
            });
            form.addEventListener(CaptchaEvent.EXPIRE, () => abortController.abort(), {
                once: true,
                signal
            });

            captchaInput.dispatchEvent(new CustomEvent(CaptchaEvent.EXECUTE));
        });
    });
}

export default function initCaptchaInterceptor(): void {
    document.querySelectorAll<HTMLFormElement>('form').forEach((form) => {
        if (
            form.closest('dialog') ||
            form.getAttribute('is') === 'nh-login-form' ||
            form.getAttribute('is') === 'landlord-registration-form'
        ) {
            return;
        }

        const captchaInput = form.querySelector<HTMLInputElement>('[data-role="cf-turnstile"]');
        if (!captchaInput) {
            return;
        }

        initFormSubmitInterceptor(form, captchaInput);
        initSocialLoginInterceptor(form, captchaInput);
    });
}
